import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const HeaderQuoteAiView = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="main">
      <div className="pageformBloack fixedviewheader">
        <div className="container-fluid gx-0 mb-3">
          <div className="pageLeftBlock">
            <div className={`whiteBoxCont quoteHeaderBar ${isScrolled ? 'shadowFilter' : ''}`}>
              <div className="policy-header rounded quoteview_header-container">
                <div className="border-0">
                  <Card.Header className="bg-white border-0 p-0 d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-5">
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="back-button"
                          onClick={() => navigate('/quoteAI')}
                          style={{ cursor: 'pointer' }}
                        >
                          <svg
                            className="back-arrow"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M19 12H5M12 19l-7-7 7-7" />
                          </svg>
                        </div>
                        <div>
                          <div className="navigate_bar">
                            <h2 className="view_heading">Acme Corporation</h2>
                            <div className="breadcrumb lft header_fnt">
                              <Link title="Home" href="/dashboard">
                                Home
                              </Link>
                              <span title="Client" className="curr">
                                /Quote Ai/Dashboard
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="quote_buttongroup">
                      <div className="headerNavButtons gap-3">
                        <Button variant="outline-next" size="sm" className="button-icon">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            className="me-1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4 17V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V17"
                              stroke="#7C67AD"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7 10L12 15L17 10"
                              stroke="#7C67AD"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M12 15V3"
                              stroke="#7C67AD"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          Export
                        </Button>

                        <Button variant="outline-next" size="sm" className="button-icon">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 16 16"
                            fill="none"
                            className="me-1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.99998 12H2.66665C2.31302 12 1.97389 11.8595 1.72384 11.6095C1.47379 11.3594 1.33331 11.0203 1.33331 10.6667V7.33333C1.33331 6.97971 1.47379 6.64057 1.72384 6.39052C1.97389 6.14048 2.31302 6 2.66665 6H13.3333C13.6869 6 14.0261 6.14048 14.2761 6.39052C14.5262 6.64057 14.6666 6.97971 14.6666 7.33333V10.6667C14.6666 11.0203 14.5262 11.3594 14.2761 11.6095C14.0261 11.8595 13.6869 12 13.3333 12H12"
                              stroke="#7C67AD"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M4 5.99992V1.99992C4 1.82311 4.07024 1.65354 4.19526 1.52851C4.32029 1.40349 4.48986 1.33325 4.66667 1.33325H11.3333C11.5101 1.33325 11.6797 1.40349 11.8047 1.52851C11.9298 1.65354 12 1.82311 12 1.99992V5.99992"
                              stroke="#7C67AD"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M11.3333 9.33325H4.66667C4.29848 9.33325 4 9.63173 4 9.99992V13.9999C4 14.3681 4.29848 14.6666 4.66667 14.6666H11.3333C11.7015 14.6666 12 14.3681 12 13.9999V9.99992C12 9.63173 11.7015 9.33325 11.3333 9.33325Z"
                              stroke="#7C67AD"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          Print
                        </Button>

                        <Button variant="outline-next" size="sm" className="button-icon">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 16 16"
                            fill="none"
                            className="me-1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 5.33325C13.1046 5.33325 14 4.43782 14 3.33325C14 2.22868 13.1046 1.33325 12 1.33325C10.8954 1.33325 10 2.22868 10 3.33325C10 4.43782 10.8954 5.33325 12 5.33325Z"
                              stroke="#7C67AD"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10Z"
                              stroke="#7C67AD"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M12 14.6667C13.1046 14.6667 14 13.7713 14 12.6667C14 11.5622 13.1046 10.6667 12 10.6667C10.8954 10.6667 10 11.5622 10 12.6667C10 13.7713 10.8954 14.6667 12 14.6667Z"
                              stroke="#7C67AD"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M5.72668 9.00659L10.28 11.6599"
                              stroke="#7C67AD"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M10.2734 4.34009L5.72668 6.99342"
                              stroke="#7C67AD"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          Share
                        </Button>
                      </div>
                    </div>
                  </Card.Header>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderQuoteAiView;
